let domain;

if (process.env.NODE_ENV == 'production') {
	// 生产环境
	domain = "https://f.lurstar.cn/api/";
} else {
	// 开发环境
	domain = "https://f.lurstar.cn/api/";
}

export default {
	domain: domain
};
